import { Country } from '@/types'
import { Dispatch, useState } from 'react'
import { SelectCountryModal } from '../modal'

export type PhoneInputProps = {
  name?: string
  label: string
  labelClassName?: string
  inputClassName?: string
  placeholder?: string
  selectedCountry: Country
  setSelectedCountry: Dispatch<React.SetStateAction<Country>> | ((country: Country) => void)
  phoneNumber: string
  setPhoneNumber: (phone: string) => void
  maxLength: number
  className?: string
  error: string | undefined
  selectCountryButtonClassName?: string
  selectCountryListBoxClassName?: string
  optionsClassName?: string
}

export const PhoneInput = (props: PhoneInputProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleModal = () => setIsOpen(!isOpen)

  const onChangeCountry = (country: Country) => {
    props.setSelectedCountry(country)
  }

  const onChangePhoneNumber = (e: React.ChangeEvent<HTMLInputElement>) => {
    const regex = /^[0-9]*$/
    if (regex.test(e.target.value)) {
      props.setPhoneNumber(e.target.value)
    }
  }

  return (
    <>
      <div className={`flex flex-col gap-y-2`}>
        <div className="flex flex-row justify-between items-center">
          {props.label && (
            <span className={`text-white text-sm font-semibold ${props.labelClassName}`}>{props.label}</span>
          )}
        </div>
        <div className={`flex flex-row justify-between rounded-full bg-white p-1 relative ${props.inputClassName}`}>
          <button
            className={'flex gap-x-2 items-center justify-center w-1/4 m-1 rounded-full bg-slate-200'}
            onClick={toggleModal}
            type="button"
          >
            <p>{props.selectedCountry.emoji}</p>
            <p className="text-sm">{props.selectedCountry.dialCode}</p>
          </button>
          <input
            onChange={onChangePhoneNumber}
            className="p-3 text-sm md:p-[17px] w-full rounded-full border-none outline-none"
            type="text"
            value={props.phoneNumber}
            placeholder={props.placeholder}
            maxLength={props.maxLength}
          />
        </div>
        {props.error && <div className="text-boldOrange -mt-1 font-medium">{props.error}</div>}
      </div>
      <SelectCountryModal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmit={onChangeCountry}
        isoCode={props.selectedCountry.isoCode}
        dialCode={props.selectedCountry.dialCode}
      />
    </>
  )
}
